module.exports = __webpack_public_path__ + "static/img/bg.9571f7de.webp";